export const QUOTA = 'quota'
export const USERS = 'users'
export const CURRENT_USER = 'current_user'
export const USER_SECURITY = 'user_security'
